import React from "react";

export interface ContainerSize {
  width: number;
  height: number;
}

const measure = (element: HTMLElement | null): ContainerSize => ({
  width: element?.clientWidth || window.innerWidth || 0,
  height: element?.clientHeight || window.innerHeight || 0
});

/** Size of the canvas container through a ResizeObserver on the element
 *  itself, so sidebar collapses and window resizes both update it and
 *  nothing polls the DOM. */
export const useContainerSize = (
  ref: React.RefObject<HTMLElement | null>
): ContainerSize => {
  const [size, setSize] = React.useState<ContainerSize>(() =>
    measure(ref.current)
  );
  React.useEffect(() => {
    const element = ref.current;
    const update = () => setSize(measure(ref.current));
    update();
    window.addEventListener("resize", update);
    const observer = element ? new ResizeObserver(update) : null;
    if (element) observer?.observe(element);
    return () => {
      window.removeEventListener("resize", update);
      observer?.disconnect();
    };
  }, [ref]);
  return size;
};
